import { render } from "./SummerEditor.vue?vue&type=template&id=a38a20c4&ts=true"
import script from "./SummerEditor?vue&type=script&lang=ts&external"
export * from "./SummerEditor?vue&type=script&lang=ts&external"

import "./SummerEditor.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__